import React from 'react';
import Cookies from 'universal-cookie';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';

const cookies = new Cookies();

class Login extends React.Component{
    constructor(props){
        super(props);
        this.state={
            email:'',
            password:'',
            loading:false,
            message_serve_e:''
        }
    }
    handleChange=async e=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }

    iniciarSesion=async()=>{

        this.setState({message_serve_e:"",loading:true});
        API.PRODUCTS.post('users_arqui',{
            email:this.state.email,
            password:this.state.password,
        }).then(response=>{
            
            this.setState({
                loading:false
            })
            if(response.data.message=="error"){
               // alert('El usuario o la contraseña no son correctos');
                this.setState({
                    message_serve_e:"Problemas de autenticación",
                    loading:false
                })
            }else{
                
            return response;
            }
        })
        .then(response=>{
            if(response.status==200){
                
                var respuesta=response.data;
                cookies.set('id', respuesta.id, {path: "/"});
                cookies.set('name', respuesta.name, {path: "/"});
                cookies.set('last_name', respuesta.last_name, {path: "/"});
                cookies.set('pais', respuesta.pais, {path: "/"});
                cookies.set('address', respuesta.address, {path: "/"});
                cookies.set('distrito', respuesta.distrito, {path: "/"});
                cookies.set('email', respuesta.email, {path: "/"});
                cookies.set('doc_number', respuesta.doc_number, {path: "/"});
                cookies.set('phone_number', respuesta.phone_number, {path: "/"});
                cookies.set('url_photo', respuesta.url_foto, {path: "/"});
                window.location.href="/";
                
            }else{
                this.setState({
                    message_serve_e:"Problemas de autenticación",
                    loading:false
                })
            }
        })
        .catch(error=>{
           
        })

    }

    componentDidMount() {
        if(cookies.get('id')){
           window.location.href="/";
        }
    }
    

    render(){
        return(
            
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <div className="login col-lg-3 col-md-6 col-sm-8 col-xs-12 mx-auto"> 
                        <div><img src="/assets/a.png"></img></div> 
                        <h5 className="text-center">INICIAR 
                            SESIÓN</h5>
                            <div className="d-flex justify-content-center">
                                {this.state.loading==true
                                ?
                                    <BarLoader
                                        width={100}
                                        height={4}
                                        color={APP_CONFIG.spinner_color}
                                        loading={this.state.loading}
                                    />
                                :""}
                                    {this.state.message_serve_e!==''&&
                                    <div className="error">{this.state.message_serve_e}</div>
                                    }
                                    
                            </div>
                        <form id="login" onSubmit={()=> this.iniciarSesion()} className="form-login">
                            
                            <section className="col-xs-12 col-md-12">
                                <div className="form-group">                  
                                <input type="email"  onChange={this.handleChange} className="form-control" id="email" name="email" placeholder="Email" required />                 
                                </div>                
                            </section>
                            <section className="col-xs-12 col-md-12">
                                <div className="form-group">                  
                                <input type="password"  onChange={this.handleChange} className="form-control" name="password" id="password" placeholder="Contraseña" />
                                </div>                
                            </section>
                            
                                       
                            {/*<div className="form-group form-check">
                            <input type="checkbox" className="form-check-input" id="check" />
                            <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
                             </div>*/}
                            
                              <button type="button" className="btn" onClick={()=> this.iniciarSesion()} >Acceder</button>
                              <p className="text-center p-register"><a href="/register">Ó crea tu cuenta gratis</a></p>
                          
                            
                        </form>
                       
                    </div> 
                    <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                </div>
            </div>
           
        );
    
}

}
export default Login;